import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import DepositRegisterTable from '../organisms/DepositRegisterTable';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getShops } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({ getShops, getAccounts }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openModal', 'updateOpenModal', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => async (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        page,
        limit: limit || limitNum
      };

      await props.actions.getShops(searchKey);
      props.updateOpenTable(true);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);

        await this.props.actions.getShops({
          page: this.props.page,
          limit: this.props.rowsPerPage
        });
        this.props.updateOpenTable(true);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    account,
    openDrawer,
    updateOpenDrawer,
    openTable,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    page
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress
    };

    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            入金処理
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          {openTable && (
            <DepositRegisterTable
              roles={roles}
              progress={progress}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
            />
          )}
        </Paper>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
